var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('router-link',{attrs:{"to":_vm.routerLinkTo}},[_c('img',{attrs:{"src":_vm.logoWhite,"alt":"logo"}}),(_vm.showTitle)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }